export default {
  getEnvironmentVariables: function () {
    return new URLSearchParams(window.location.search);
  },
  getOuterResourceId: function () {
    let params = this.getEnvironmentVariables();

    return params.get('PUBLIC_KEY');
  },
  getOuterVersion: function () {
    let params = this.getEnvironmentVariables();

    return params.get('version');
  }
}


// WEBPACK FOOTER //
// ./src/utils/environment.js